import React from "react";

import Dashboard from "../pages/app/Dashboard";
import BattleDetail from "../pages/app/BattleDetail";
import Battles from "../pages/app/Battles";
import Leaderboard from "../pages/app/Leaderboard";
import BetHistory from "../pages/app/BetHistory";
import Profile from "../pages/app/Profile";
import Logout from "../pages/app/Authentication/Logout";
import Home from "../pages/app/Home";
import VerifyEmail from "../pages/app/VerifyEmail";
import Battle from "../pages/admin/Battle";
import BattleBets from "../pages/admin/BattleBets";
import Character from "../pages/admin/Character";
import User from "../pages/admin/User";
import UserDetail from "../pages/admin/UserDetail";
import Parameter from "../pages/admin/Parameter";


const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/battles", component: <Battles /> },
  { path: "/bets/history", component: <BetHistory /> },
  { path: "/profile", component: <Profile /> },
  { path: "/leaderboard", component: <Leaderboard /> },
  { path: "/battles/:battleId", component: <BattleDetail /> },
  { path: "/admin/battles", component: <Battle /> },
  { path: "/admin/battles/:battleId/bets", component: <BattleBets /> },
  { path: "/admin/users", component: <User /> },
  { path: "/admin/users/:userId", component: <UserDetail /> },
  { path: "/admin/characters", component: <Character /> },
  { path: "/admin/parameters", component: <Parameter /> },
];

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/verify", component: <VerifyEmail /> },
  { path: "/ref/:username", component: <Home /> },
  { path: "/", component: <Home /> },
];

export { authProtectedRoutes, publicRoutes };
